export default __webpack_public_path__ + "static/media/spinner.57c57502.gif";